module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/WeWereFeatured/assets/newYorkTimes-f7f985d76d2c0497e0783a35f78bf539.png";